import { defineMessages } from 'react-intl'

export default defineMessages({
  changeMe: {
    id: 'components.SelectPaymentMethod.changeMe',
    defaultMessage: '请修改',
    description: '请修改',
  },
  alertTitle: {
    id: 'components.SelectPaymentMethod.alertTitle',
    defaultMessage: 'Confirm Payment',
    description: 'Alert: title',
  },
  alertP1: {
    id: 'components.SelectPaymentMethod.alertP1',
    defaultMessage: 'A. Finish the payment? Confirm to go further.',
    description: 'Alert: p1',
  },
  alertP2: {
    id: 'components.SelectPaymentMethod.alertP2',
    defaultMessage: 'B. Back to retry another method.',
    description: 'Alert: p2',
  },
  alertP3: {
    id: 'components.SelectPaymentMethod.alertP3',
    defaultMessage: 'Get your app and gain more points.',
    description: 'Alert: p3',
  },
  alertBtnBack: {
    id: 'components.SelectPaymentMethod.alertBtnBack',
    defaultMessage: 'Back',
    description: 'Alert: buttom back',
  },
  alertBtnConfirm: {
    id: 'components.SelectPaymentMethod.alertBtnConfirm',
    defaultMessage: 'Confirm',
    description: 'Alert: buttom confirm',
  },
  notAvailable: {
    id: 'components.SelectPaymentMethod.notAvailable',
    defaultMessage: 'Not available for this transaction',
    description: 'Not available',
  },
})
